// extracted by mini-css-extract-plugin
export default {"bannerContentContainer":"G0b7pu","bannerText":"bONvUB","homeBannerText":"WzCnik","accountBanner":"lqwzb2","homeBanner":"h8aavH","closeButton":"PtYcqI"};